import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import search from "../../assets/icons/searchIcon.svg";

// Sample data for reports
const reportsData = [
    {
        id: 1,
        title: "Inventory Report",
        description: "Monitor your inventory in real-time with stock levels, batch details, and expiration dates. Ensure accuracy and prevent stockouts or overstocking.",
        path: "/reports/inventory"
    },
    {
        id: 2,
        title: "Product Wise Sales Report",
        description: "Analyze your sales trends, revenue, and product performance. Gain insights into top-selling products and seasonal sales patterns.",
        path: "/reports/product-sales"
    },
    {
        id: 3,
        title: "Customer Report",
        description: "Understand customer purchase patterns and preferences. Access detailed insights into orders, purchase frequency, and average spending.",
        path: "/under-dev"
    },
    {
        id: 4, title: "Stock Inflow Report",
        description: "View and manage stock inflows, including purchase orders and vendor deliveries. Ensure accurate updates to your inventory.",
        path: "/reports/stock-in"
    },
    {
        id: 5, title: "Stock Return Report",
        description: "Track and manage all returned items to maintain inventory accuracy. Prevent losses by identifying return reasons and patterns.",
        path: "/under-dev"
    },
];

const Reports = () => {
    const [searchTerm, setSearchTerm] = useState("");
    const navigate = useNavigate();

    // Filter reports based on search term
    const filteredReports = reportsData.filter((report) =>
        report.title.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <div className="flex items-center justify-center bg-gray-100" style={{ height: "95vh" }}>
            <div className="w-full mx-6 bg-white shadow-lg rounded-md flex flex-col p-4" style={{ height: '95%' }}>

                {/* Search Bar */}
                <div
                    style={{ height: "2.5rem" }}
                    className={`input_border flex items-center rounded-md w-full sm:w-auto mx-1 md:w-80 mb-6`}
                >
                    <span className="px-2">
                        <img width={"16px"} src={search} alt="search icon" />
                    </span>
                    <input
                        placeholder={`Search here`}
                        className="table_search_input w-full rounded-md fs_12 placeholder:text-fs_12"
                        type="text"
                        value={searchTerm}
                        onChange={(e) => {
                            setSearchTerm(e?.target?.value);
                        }}
                    />
                    <span className='fs_14 mx-3 cursor-pointer text-primary' onClick={() => setSearchTerm('')} >Clear</span>
                </div>

                {/* Report Cards */}
                <div className="border rounded overflow-auto" style={{ height: '90%' }}>
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6  p-4" >
                        {filteredReports.map((report) => (
                            <div
                                key={report.id}
                                className="bg-white shadow-lg rounded-lg p-4 hover:shadow-xl transition transform hover:scale-105 cursor-pointer h-44 overflow-auto"
                                onClick={() => navigate(report.path)}
                            >
                                <h3 className="text-xl font-bold text-primary text-start mb-2">{report.title}</h3>
                                <p className="text-gray-600 text-start mt-4">{report.description}</p>
                            </div>
                        ))}
                    </div>
                </div>


                {/* No Results Found */}
                {filteredReports.length === 0 && (
                    <p className="text-center text-gray-500 mt-6">No reports found.</p>
                )}
            </div>
        </div>
    );
};

export default Reports;
